export { default as Autocomplete } from './inputs/Autocomplete';
export { default as DatePicker } from './inputs/DatePicker';
export { default as Input } from './inputs/Input';
export { default as SearchChip } from './inputs/SearchChip';
export { default as Select } from './inputs/Select';
export { default as Switch } from './inputs/Switch';
export { default as TagsPicker } from './inputs/TagsPicker';
export { default as CustomerSwitch } from './inputs/Switch';
export { default as CheckBoxChoose } from './inputs/CheckBoxChoose';
export { default as TimePicker } from './inputs/TimePicker';
export { default as CascadeSelect } from './inputs/CascadeSelect';
export { default as UploadFile } from './inputs/UploadFile';
export { default as Slider } from './inputs/Slider';
